import React from "react";
import { Doughnut } from "react-chartjs-2";
import { ThemeType } from "../../types/index";
import { useOptions, useRoundData } from "../../hooks/useGraph";
import { DataType } from "../../types/dataType";
import { dummyRound } from "../../contains/dummyData";

export type DoughnutChartProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
  data: DataType;
  theme?: ThemeType;
};

export const doughnutChartDefaultProps = {
  data: dummyRound,
};

const DoughnutChart = ({
  data,
  className,
  height,
  width,
  theme,
}: DoughnutChartProps): JSX.Element => {
  const opt = useOptions("doughnut", theme);
  const chartData = useRoundData(data);

  return (
    <Doughnut
      data={chartData}
      className={className}
      options={opt}
      height={height}
      width={width}
    />
  );
};

DoughnutChart.defaultProps = doughnutChartDefaultProps;

export default DoughnutChart;
